
/**
 * みポイント数を更新する
 * @param  {Number} pointsToAdd - 現在の合計に足すポイント数
 */
function addToPointsTotal(pointsToAdd) {
  // HTML要素を取得
  var $pointsCounter = $('.login-success .points__counter');
  var $pointsText = $pointsCounter.find('.points__number--login');
  var countTo = $pointsText.data('count');
  
  if ($pointsText.length > 0) {
    // 変数の規定
    pointsToAdd = pointsToAdd || $pointsText.text();

    $({ countNum: pointsToAdd })
    .animate({
      countNum: countTo
    },
    {
      duration: 4000,
      easing: 'linear',
      start: function() {
        $pointsCounter.removeClass('js-count-done');
      },
      step: function() {
        $pointsText.text(Math.floor(this.countNum));
      },
      complete: function() {
        $pointsText.text(this.countNum);
        $pointsCounter.addClass('js-count-done');
      }
    })
  }
}

addToPointsTotal();